<script setup lang="ts">
import MdiFaIcon from '../MdiFaIcon.vue';
import Menu from '../Menu.vue';
import { AdditionalControl } from '../types/share';
import useLocale from '../helpers/use-locale';

type Emits = {
  (e: 'itemEvent', event: string): void;
  (e: string, ...args: any[]): void; // dynamic events
};
const emit = defineEmits<Emits>();

type Props = {
  items: AdditionalControl[];
};
defineProps<Props>();

const onItemEvent = (event: string) => {
  emit('itemEvent', event); // to be able to forward it further into the parent component
  emit(event);
};

const { t } = useLocale();
</script>

<template>
  <Menu :title="t('components.label_advanced_menu')">
    <v-list-item
      v-for="(item, index) in items"
      :key="index"
      :value="index"
      color="red"
      @click="onItemEvent(item.eventName)"
    >
      <v-list-item-title :style="{ color: item.fontColor }">
        <MdiFaIcon v-if="item.icon" :icon="item.icon" class="mr-2" v-bind="item.iconProps" />
        {{ item.title }}
      </v-list-item-title>
    </v-list-item>
  </Menu>
</template>

<style scoped lang="scss">
.v-list {
  padding: 0;
  border-radius: 10px;
}

.v-list-item {
  border-bottom: 1px solid transparent;

  &:last-child {
    border-bottom: none;
  }
}
</style>
